module.exports = __webpack_public_path__ + "img/u10.32b3173b.png";